import { render } from "./AccountMenu.vue?vue&type=template&id=8628c8bc&scoped=true"
import script from "./AccountMenu.vue?vue&type=script&lang=js"
export * from "./AccountMenu.vue?vue&type=script&lang=js"

import "./AccountMenu.vue?vue&type=style&index=0&id=8628c8bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8628c8bc"]])

export default __exports__